import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Test(props) {
  const {
    paginator,
    vertical,
    showMore
  } = props;
  const cardStyle = {
    minWidth: '80px',
    display: 'inline-block',
    textAlign: 'center',
    border: '1px solid #eeeeee',
    whiteSpace: 'nowrap',
    padding: '16px',
    margin: '8px'
  };
  const layout = {
    overflow: 'auto',
    display: 'flex',
    flexDirection: vertical ? 'column' : 'row',
    justifyContent: 'center',
    alignItems: 'stretch'
  };
  if (!showMore) {
    return /*#__PURE__*/_jsxs("div", {
      style: layout,
      children: [/*#__PURE__*/_jsxs("div", {
        style: cardStyle,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Page"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "caption",
          children: paginator.displayPage
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: cardStyle,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Page Count"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "caption",
          children: paginator.pages
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: cardStyle,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Per Page"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "caption",
          children: paginator.perPage
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: cardStyle,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Item Count"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "caption",
          children: paginator.count
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: cardStyle,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Showing"
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "caption",
          children: [paginator.displayStartIndex, " to ", paginator.displayEndIndex]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    style: layout,
    children: [/*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Page"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.displayPage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Page Count"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.pages
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Per Page"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.perPage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Item Count"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.count
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Showing"
      }), /*#__PURE__*/_jsxs(Text, {
        variant: "caption",
        children: [paginator.displayStartIndex, " to ", paginator.displayEndIndex]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Other"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.displayPage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Fun "
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.pages
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Aggs"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.perPage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "And"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: paginator.count
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: cardStyle,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "subtitle",
        children: "Alerts"
      }), /*#__PURE__*/_jsxs(Text, {
        variant: "caption",
        children: [paginator.displayStartIndex, " to ", paginator.displayEndIndex]
      })]
    })]
  });
}
export default connect()(Test);